import React from "react";
import { Form, Formik } from "formik";
import { Term } from "iam-client/dist/client/shared/termsOfServices";
import { OnTermsAndConditionsRetrievedApi } from "iam-client/dist/wrapper/shared";
import { useMessageSource } from "react-message-source";
import ApplicationPageContent from "../../../ui/layout/page/content/application";
import ContentFooter from "../../../ui/layout/page/content/footer";
import NavigationBar from "../../../ui/layout/page/content/footer/navigation-bar";
import FormContainer from "../../../ui/layout/page/forms-container/form-base-container";
import useTermsOfServiceValidationScheme from "./validator";
import TermsOfServiceCheckbox from "../../../ui/widgets/checkbox/checkbox-terms-of-service";

import logging from "../../../util/logging";
import TypographyContainer from "../../../ui/layout/page/typography-container/typography-base-container";
import TypographyItemContainer from "../../../ui/layout/page/typography-container/typography-item-container";
import CustomTypography from "../../../ui/widgets/typography";
const log = logging("T&C page");

interface TermsOfServiceProps {
  onNext: OnTermsAndConditionsRetrievedApi;
}

const TermsOfService = ({ onNext }: TermsOfServiceProps): React.JSX.Element => {
  const { getMessage } = useMessageSource();

  const initialValues = {
    acceptTermsAndConditions: false,
  };

  const terms: Term[] = onNext.data.terms;

  const handleOnSubmit = async () => {
    if (onNext) {
      onNext.proceed(true);
    } else {
      log.error(
        "Login flow: Cannot proceed in T&C submit, due to a missing callback",
      );
    }
  };

  return (
    <ApplicationPageContent>
      <Formik
        validationSchema={useTermsOfServiceValidationScheme()}
        onSubmit={handleOnSubmit}
        initialValues={initialValues}
      >
        {({ handleSubmit }) => {
          return (
            <Form>
              <FormContainer>
                <TypographyContainer>
                  <TypographyItemContainer>
                    <CustomTypography variant="h3">
                      {getMessage("NewTermsOfService.title")}
                    </CustomTypography>
                  </TypographyItemContainer>
                  <TypographyItemContainer>
                    <CustomTypography variant="body1">
                      {getMessage("NewTermsOfService.description")}
                    </CustomTypography>
                  </TypographyItemContainer>
                </TypographyContainer>

                <div className="scd-section-pusher-md">
                  <TermsOfServiceCheckbox terms={terms} />
                </div>
              </FormContainer>

              <ContentFooter>
                <NavigationBar
                  onNext={handleSubmit}
                  nextButtonText={getMessage("Onboarding.continue")}
                />
              </ContentFooter>
            </Form>
          );
        }}
      </Formik>
    </ApplicationPageContent>
  );
};

export default TermsOfService;
